import {
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';
import {
  activeKeyQueryKeys,
  activityTabKeys,
  activityTabQueryKeys,
  shareBySheetKeys,
} from '../_utils/search-query-states';

// sheet特有のものは分けるようにしたいが、RSとSSだけのようなものもあるので１つにまとめ運用でカバーする。
export const useProjectDetailSearchQueryStates = () => {
  return useQueryStates({
    // 共通
    [shareBySheetKeys.Enum.activeKey]: parseAsStringLiteral(
      activeKeyQueryKeys.options,
    ),
    //// 効果発現経路（RS/SS）
    [activityTabQueryKeys.Enum.routeIndicatorIds]:
      parseAsArrayOf(parseAsString),
    [activityTabQueryKeys.Enum.activitiesTabKey]: parseAsStringLiteral(
      activityTabKeys.options,
    ).withDefault('activities'),
  });
};
